export default __webpack_public_path__ + "static/media/user-icon.b1280719.svg";